export default __webpack_public_path__ + "static/media/mongodb.e8169cbb.png";